// useStopKey — Escape while a turn is drafting stops it, through the ONE
// stamped keyboard door (`applyTrigger` → the `stop-turn` UiIntent → the
// root raises `Signal.StopRequested`, which chat owns). Behaviour kept from
// the former chat bridge: the listener exists only while the selected
// conversation drafts, never `preventDefault`s, and claims no chord (web
// registers zero chords besides ⌘K; IDD 5320d96f/dfd31976).

import { useEffect } from "react";
import type { TriggerSignal } from "../trigger.js";

export const useStopKey = (
    drafting: boolean,
    applyTrigger: (signal: TriggerSignal) => void,
): void => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: binds the door of the render where drafting began, exactly as before.
    useEffect(() => {
        if (!drafting) return;
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape")
                applyTrigger({
                    provenance: { type: "user" },
                    action: { type: "key", action: { type: "stop-turn" } },
                });
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [drafting]);
};
